import React from 'react';
import PropTypes from 'prop-types';
import { IframeStyled, DivStyled } from './styles';

const MapComponent = ({
  address = {
    street: '720 E Wisconsin Ave',
    building: '',
    city: 'Milwaukee',
    state: 'WI',
    zip: '53202',
  },
  className,
  config = { public: { googlePlacesApiKey: '<%=googlePlacesApiKey%>' } },
  coordinates,
  id,
  themeType = 'lightTheme',
  ...rest
}) => {

  const addressString = coordinates?.latitude && coordinates?.longitude
    ? `${coordinates.latitude},${coordinates.longitude}`
    : `${address.street} ${address.building || ''} ${address.city}, ${address.state} ${address.zip}`;
  const mapIframeSrc = `https://www.google.com/maps/embed/v1/place?key=${config.public.googlePlacesApiKey}&q=${encodeURIComponent(addressString)}`;

  return (
    <DivStyled
      themeType={themeType}
      className={className}
      itemScope
      itemType='https://schema.org/Map'
      id={id}
      {...rest}
    >
      <IframeStyled
        title={`Google Map for ${addressString}`}
        src={mapIframeSrc}
        allowFullScreen=""
        loading="lazy"
      />
    </DivStyled>
  );
};

MapComponent.propTypes = {
  /** One of address or coordinates is required */
  /** Address of the map */
  address: PropTypes.shape({
    street: PropTypes.string.isRequired,
    building: PropTypes.string,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
  }),
  /** Custom class name to add to Type. */
  className: PropTypes.string,
  config: PropTypes.shape({ public: PropTypes.shape({ googlePlacesApiKey: PropTypes.string.isRequired }).isRequired }).isRequired,
  /** Coordinates of the map */
  coordinates: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }),
  /** Required id attribute */
  id: PropTypes.string.isRequired,
  /** themeType allows for different color themes */
  themeType: PropTypes.oneOf(['lightTheme']),
};

export default MapComponent;